import { Heart } from 'lucide-react';

export function Footer() {
  return (
    <footer className="py-4 text-center text-sm text-gray-600 bg-white bg-opacity-50 border-t border-gray-200 mt-auto">
      <p>© {new Date().getFullYear()} Vases d'Honneur Angré Djibi 3. Tous droits réservés. - Version 2.2.1</p>
      <p className="mt-1 text-xs flex items-center justify-center">
        Développé avec <Heart size={12} className="mx-1 text-red-500 fill-current" /> par l'équipe technique Vases d'Honneur Angré Djibi 3
      </p>
    </footer>
  );
}